
























import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';
import env from '@/env';

@Component
export default class TimelineView extends Vue {
  private all_waves: Array<object> = [];

  private wave_name = '';

  private wave_abbreviation = '';

  private wave_sequence = 0;

  async created() {
    this.$emit('showPreloader');
    const { data } = await axios.get(`${env.backend_url}/all_waves`);
    this.all_waves = data;
    this.$emit('loadingFinished');
  }
}
